import React, { useEffect } from 'react';
import { onMessageListener } from '../firebase';

export const NotificationListener = () => {
  useEffect(() => {
    const listen = async () => {
      try {
        const payload = await onMessageListener();
        console.log('📩 Foreground FCM message:', payload);

        const { title, body } = payload?.notification || {};

        // ✅ Check window and Notification existence
        if (typeof window !== 'undefined' && 'Notification' in window && Notification.permission === 'granted') {
          new Notification(title, { body });
        } else {
          console.warn('🚫 Notifications not supported or permission not granted.');
        }

        // You could also push to a toast or in-app notification system
      } catch (err) {
        console.error('🔥 Error in message listener:', err);
      }
    };

    listen();
  }, []);

  return null;
};
